import styled from "@emotion/styled"
import { Box, Flex } from "@rebass/grid/emotion"
import { Link } from "gatsby"
import { queries } from "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const ProductSectionWrap = styled.section`
  img {
    width: 100%;
  }
  .product-section-wrap {
    padding-top: 0 !important;
  }
  @media (max-width: 767px) {
    .product-section-wrap {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    padding-top: 48px !important;
  }
  ${queries.large`
    .product-section-wrap {
      margin-top: -224px;
    }
  `}
`

export const GwpColumnFlex = styled(Flex)`
  flex-direction: column;
  @media (min-width: 1520px) {
    position: relative;
    justify-items: center;
    padding-bottom: 40px;
  }
`

export const CardBox = styled(Box)`
  border-top: 1px solid ${theme.wild.color.nova.transparency.black[20]};
  &:not(:first-of-type, :nth-child(2)) {
    border-bottom: 1px solid ${theme.wild.color.nova.transparency.black[20]};
  }
  &:nth-child(even) {
    border-left: 1px solid ${theme.wild.color.nova.transparency.black[20]};
  }
  ${queries.medium`
    border-bottom: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    &:first-of-type {
      border-bottom-left-radius: 4px;
      border-left: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    }
    &:nth-child(3) {
      border-left: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    }
    &:last-of-type {
      border-bottom-right-radius: 4px;
      border-right: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    }
  `}
`

export const ProductLink = styled(Link)``

export const BottomWrap = styled.div``
